// src/utils/ssn.ts
// Renders an SSN so that only the last four characters are visible.

export const maskSsn = (value: unknown): string => {
    if (value === null || value === undefined) {
        return "";
    }

    const raw = String(value).trim();

    if (!raw || raw.length <= 4) {
        return raw;
    }

    return `xxx-xx-${raw.slice(-4)}`;
};
